import { useContext } from 'react';
import { RepositoriesContext } from '../repositories/RepositoriesContext';
import type { Repositories } from '../repositories/Repositories';

/** The repositories for this render: the real ones in the app, fakes in tests. */
export function useRepositories(): Repositories {
  return useContext(RepositoriesContext);
}
